import { LazyRoute } from "common/routes/route.types";
import { routes } from "common/routes/routes";
import { bookingRoutesBase } from "modules/booking/routes";

export const settingRoutes: LazyRoute = {
  ...routes.settings.basePath,
  id: routes.settings.basePath.text,
  importComponent: () => import("modules/settings/Index"),
  children: [
    {
      ...routes.settings.networkAndSecurity,
      importComponent: () =>
        import("modules/settings/pages/NetworkAndSecurityScreen"),
      id: routes.settings.networkAndSecurity.text
    },
    {
      ...routes.settings.mobileLicences,
      importComponent: () =>
        import("modules/settings/pages/UserLicencesScreen"),
      id: routes.settings.mobileLicences.text
    },
    {
      ...routes.settings.home,
      importComponent: () => import("modules/settings/pages/ProductsScreen"),
      id: routes.settings.home.text
    },
    {
      ...routes.settings.bestHealthBooking,
      importComponent: () => import("modules/booking/Index"),
      children: bookingRoutesBase,
      id: routes.settings.bestHealthBooking.text
    }
  ]
};
